import styled from "styled-components"
import { useDispatch } from "react-redux"
import { IoCreateOutline } from "react-icons/io5";
import create from "../../images/svg/create-chat.svg"
import { useSelector } from "react-redux";
import { getSupportChatById, setArchiveChat, setMessageRead, setSelectedChat } from "../../features/messages/messageSlice";
import moment from "moment";
import { useEffect, useState } from "react";
import { MdOutlineArchive } from "react-icons/md";
import { GrLinkPrevious } from "react-icons/gr";
import { MdArrowBack } from "react-icons/md";
import { markNotificationAsRead, setSelectedNotification } from "../../features/notification/notificationSlice";


const Container = styled.div`
    width: 270px;
    max-height: 90vh;
    min-height: auto;
    overflow-y: auto;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    color: ${({theme}) => theme.mainTextColor};
    margin-right: 20px;

    .message-kamyoon{
        background: var(--color-main);
        width: 100%;
        height: 45px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 8px;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        position: relative;
        padding-inline: 20px;
        span{
            font-size: var(--font-size-xs);
            font-weight: var(--font-weight-lg);
            background-color: #fff;
            color: var(--color-main);
            padding: 3px;
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
        p{
            font-size: var(--font-size-md);
            font-weight: var(--font-weight-xl);
            color: #fff;
            display: flex;
            align-items: center;
            gap: 5px;
        }
    }

    .titles-list{
        display: flex;
        flex-direction: column;
        border: 1px solid ${({theme}) => theme.mainBorderColor};
        border-top: none;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        max-height: 65vh;
        overflow-y: auto;
        &::-webkit-scrollbar {
            height: 8px;
            width: 5px;
        }
        &::-webkit-scrollbar-thumb {
            background-color: ${({theme})=> theme.secondaryTextColor};
            /* border-radius: 10px; */
        }
        &::-webkit-scrollbar-track {
            background-color: transparent;
        }
        .chat-item{
            border-bottom: 2px solid ${({theme}) => theme.mainBorderColor};
            padding: 20px;
            cursor: pointer;
            display: flex;
            flex-direction: column;
            gap: 7px;
            position: relative;
            .chat-text{
                font-size: var(--font-size-md);
                font-weight: var(--font-weight-lg);
            }
            .notification{
                position: absolute;
                top: 10px;
                right: 10px;
                font-size: var(--font-size-xs);
                font-weight: var(--font-weight-lg);
                color: var(--color-main);
            }
            .date{
                font-size: var(--font-size-xs) !important;
                font-weight: var(--font-weight-md) !important;
            }
        }
        .chat-item:last-child{
            border-bottom: none !important;
        }
    }
    
    
    .select-chat{
        background-color: ${({theme})=> theme.secondaryBgColor};
    }
   
`

const NotificationTabSide = () => {
    const {notificationList, selectedNotification} = useSelector((state) => state.notification)
    const dispatch = useDispatch()
    const [notificationCount, setNotificationCount] = useState(0)

  useEffect(() => {
    setNotificationCount(notificationList.filter(item => item.isRead === false).length)
  },[notificationList])

    return (
    <Container>
        <div className="message-kamyoon">
            <p>Bildirimler {notificationCount > 0 && <span>{notificationCount}</span>}</p>
        </div>
        <div className="titles-list">
            {notificationList?.length > 0 &&
            <>
                {notificationList.map((item) => {
                    const now = moment();
                    const notificationTime = moment(item.createOn);

                    let displayTime;
                    if (now.isSame(notificationTime, "day")) {
                        const hoursAgo = now.diff(notificationTime, "hours");
                        displayTime = `${hoursAgo} saat önce`;
                    } else if (now.subtract(1, "days").isSame(notificationTime, "day")) {
                        displayTime = `Dün ${notificationTime.format("HH:mm")}`;
                    } else {
                        displayTime = notificationTime.format("DD.MM.YYYY HH:mm");
                    }
                    return (
                        <div key={item.id} className={`chat-item ${item?.id === selectedNotification?.id ? "select-chat" : ""}`} onClick={() => {dispatch(markNotificationAsRead({id: item.id})); dispatch(setSelectedNotification(item))}}>
                            <div className="chat-text">{item.title}</div>
                            <span className="date">{displayTime}</span>
                            {item.isRead === false && <div className="notification">Okunmadı</div>}
                        </div>
                    )
                })}
            </> 
            }
        </div>
    </Container>
  )
}

export default NotificationTabSide